import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { ConfirmationService, Message } from 'primeng/api';
import { Table } from 'primeng/table';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { PlanoContaEmpresaFiltro } from 'src/app/admihair/api/dto/filtros/plano-conta-empresa-filtro';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { EmpresaService } from 'src/app/admihair/service/empresa.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';

@Component({
  selector: 'app-plano-contas-empresa-listar',
  templateUrl: './plano-contas-empresa-listar.component.html',
  styleUrls: ['./plano-contas-empresa-listar.component.scss']
})
export class PlanoContaEmpresaListarComponent implements OnInit {

  constructor(private empresaService: EmpresaService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private confirmationService: ConfirmationService,
    private erroService: ErroService) { }

  loading: boolean = false;
  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  @Output() emissor = new EventEmitter();
  @Input() empresaSelecionada?: Empresa;
  @Input() modoDetalhar: boolean = false;
  planosContaEmpresa: PlanoContaEmpresa[] = [];
  planoContaEmpresaFiltro: PlanoContaEmpresaFiltro = {};

  @ViewChild('filter') filter!: ElementRef;

  ngOnInit(): void {
    this.listarPlanosContaEmpresa();
  }

  listarPlanosContaEmpresa() {
    this.planoContaEmpresaService.listarPorEmpresa(this.empresaSelecionada?.id).subscribe({
      next: (data: PlanoContaEmpresa[]) => {
        this.planosContaEmpresa = data;
      },
      error: (err: any) => {
        console.log('erro ao buscar: ', err);
      }
    });
  }

  editar(id?: number) {
    this.emissor.emit({ id: id, modo: 'EDITAR' });
  }

  detalhar(id?: number) {
    this.emissor.emit({ id: id, modo: 'DETALHAR' });
  }

  excluir(id?: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.planoContaEmpresaService.excluir(id).subscribe({
          next: () => {
            this.listarPlanosContaEmpresa();
            this.messages = this.erroService.handleSuccess();
            this.messagemVisivel = true;
            this.rolarTela();
          },
          error: (err: any) => {
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        })
      }
    });
  }


  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
